import { style } from '@vanilla-extract/css';

export const container = style({
  display: 'flex',
  flexDirection: 'row',
  gap: '0.25rem',
  justifyContent: 'center',
  padding: '0.625rem',
  alignItems: 'center',
  borderRadius: '0.625rem',
  background: '#fff',
  zIndex: 2,
});
